import type { Immutable } from "immer";
import React from "react";

import type { HotSpotBlock as HotSpotBlockValue } from "@reactivated";

import { HotspotBlock } from "../../apps/product-detail/Hotspot";
import type { IHotspotContent } from "../../apps/product-detail/models";

/**
 * Native Reactivated wrapper for the TP-local HotSpotBlock (#33452 / SSR-V2
 * Phase 1).
 *
 * Converts the block OFF the legacy ``cms_data: str`` JSON round-trip: the block
 * value is now serialized natively (``value: HotSpotBlock``) and ``variant`` (a
 * page/request-derived field, not a block field) is threaded through the
 * ``include_react`` shim by the ``hotspot_variant`` templatetag. The richtext
 * transforms (header = raw ``.source``; hotspots = ``clean_rich_text``) are
 * preserved server-side in ``HotSpotBlock.get_data_for_client_render``, so the
 * strings handed to the (UNCHANGED, interactive) ``HotspotBlock`` component are
 * byte-identical to what ``JSON.parse(cms_data)`` produced before.
 *
 * Field order matters: ``HotspotBlock`` derives the accordion item ids from
 * ``Object.keys`` and opens ``tipIds[1]`` (the second hotspot) by default, so
 * ``hotspot_one`` / ``hotspot_two`` / ``hotspot_three`` are assembled in that
 * order to keep ``hotspot_two`` the default-open item (legacy parity).
 */
export const HotSpotBlock = (
    props: Immutable<{ value: HotSpotBlockValue; variant: string }>,
): React.ReactNode => {
    const v = props.value;
    const hotspotContent: IHotspotContent = {
        header_content: v.header_content ?? "",
        hotspot_one: v.hotspot_one ?? "",
        hotspot_two: v.hotspot_two ?? "",
        hotspot_three: v.hotspot_three ?? "",
        variant: props.variant,
    };
    return <HotspotBlock hotspotContent={hotspotContent} />;
};
